import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { getAllGoalsAsync } from "../async.api";

const initialState = {
  goalLoader: false,
  getAllGoals: [],
};

export const goalsSlice = createSlice({
  name: "goals",
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getAllGoalsAsync.pending), (state) => {
      state.goalLoader = true;
    });
    builder.addMatcher(isAnyOf(getAllGoalsAsync.fulfilled), (state, action) => {
      state.goalLoader = false;
      state.getAllGoals = action.payload.data;
    });
    builder.addMatcher(isAnyOf(getAllGoalsAsync.rejected), (state, action) => {
      state.goalLoader = false;
    });
  },
});

export default goalsSlice.reducer;
